import ManageServices from "./ManageServices";


export const getUserRouting = async (payload) => {
    try {
      const response = await ManageServices.getUserRoutingByID(payload);
  
      console.log("getUserRouting RESP", response);
      const data = await response.data;
      return data;
    } catch (err) {
      console.log("ERROR in manageData User Permissions", err);
    }
  };


  export const getUserAddressData = async () => {
    try {
      const response = await ManageServices.getAddress();
      // console.log("RESP", response);
      const data = await response.data;
  
      return data;
    } catch (err) {
      console.log("ERROR in manageData USERs", err);
    }
  };


